import React from 'react';
import { ImagePlus } from 'lucide-react';
interface HeadlineImageSlotProps {
  /** Optional image URL. When omitted, an empty placeholder is shown. */
  src?: string;
  alt?: string;
}
/**
 * A drop-in space beneath a section headline where an image can be added.
 * Renders the image when `src` is provided, otherwise shows a dashed
 * placeholder prompting the user to add one.
 */
export function HeadlineImageSlot({
  src,
  alt = ''
}: HeadlineImageSlotProps) {
  if (src) {
    return <img src={src} alt={alt} className="w-full h-64 object-cover rounded-xl mb-8" data-id="element-225" />;
  }
  return <div className="w-full h-48 mb-8 rounded-xl border-2 border-dashed border-brand-rose-light bg-brand-rose-light/10 flex flex-col items-center justify-center text-brand-rose-dark/70" data-id="element-226">
      <ImagePlus className="w-7 h-7 mb-2" data-id="element-227" />
      <span className="text-sm font-medium" data-id="element-228">Add image here</span>
    </div>;
}